(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-shipping-details"]) return;
  try {
    
  (() => {
    if (window.bwShippingDetailsInitialized) return;
    window.bwShippingDetailsInitialized = true;
    let returnFocus;
    const bindDialog = () => {
      const dialog = document.getElementById('bw-shipping-dialog');
      if (!dialog || dialog.dataset.bwBound) return dialog;
      dialog.dataset.bwBound = 'true';
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('bw-shipping-is-open');
        if (returnFocus?.isConnected) returnFocus.focus({preventScroll: true});
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      return dialog;
    };
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const opener = event.target.closest('[data-bw-shipping-open]');
      const closer = event.target.closest('[data-bw-shipping-close]');
      if (!opener && !closer) return;
      const dialog = bindDialog();
      if (!dialog || typeof dialog.showModal !== 'function') return;
      if (opener && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
      event.preventDefault();
      event.stopPropagation();
      if (closer) { dialog.close(); return; }
      returnFocus = opener;
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('bw-shipping-is-open');
    }, true);
    const enhanceBanner = (root = document) => {
      const template = document.getElementById('bw-shipping-banner-template');
      if (!template) return;
      const wrappers = root.matches?.('.essential_free_shipping_bar_wrapper') ? [root] : [...root.querySelectorAll('.essential_free_shipping_bar_wrapper')];
      wrappers.forEach(wrapper => {
        const title = wrapper.querySelector('[class*="free_shipping_bar_title_"]');
        if (title && !title.querySelector('[data-bw-shipping-open]')) title.append(template.content.cloneNode(true));
      });
    };
    const start = () => {
      bindDialog();
      enhanceBanner();
      new MutationObserver(records => {
        const wrappers = new Set();
        for (const record of records) {
          if (record.target instanceof Element) {
            const wrapper = record.target.closest('.essential_free_shipping_bar_wrapper');
            if (wrapper) wrappers.add(wrapper);
          }
          for (const node of record.addedNodes) if (node instanceof Element && !node.matches('[data-bw-shipping-open]')) enhanceBanner(node);
        }
        wrappers.forEach(enhanceBanner);
      }).observe(document.body, {childList: true, subtree: true});
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
    document.addEventListener('shopify:section:load', () => { bindDialog(); enhanceBanner(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-spoks-takeover"] && !Shopify.designMode) return;
  try {
    
function compactBwSpoks(root,attempt=0){const host=root.querySelector('[data-spoks-form-id] .needsclick');const shadow=host&&host.shadowRoot;if(!shadow){if(attempt<40)setTimeout(()=>compactBwSpoks(root,attempt+1),250);return;}if(shadow.querySelector('[data-bw-mobile-style]'))return;const style=document.createElement('style');style.dataset.bwMobileStyle='true';style.textContent=`@media(max-width:600px){:host>div>div>div[style]{padding:0!important}.py-8.px-7{padding:14px 16px!important;border-radius:12px}h3[slot="title"]{display:none}h3[slot="title"]+.pt-3{padding-top:0;font-size:16px;line-height:1.35}.pt-6{padding-top:14px}.space-y-5>:not([hidden])~:not([hidden]){margin-top:12px}.pt-4{padding-top:0}form label{font-size:14px;line-height:1.35}form label[for]{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}form label[data-react-aria-pressable]{text-align:left;min-height:44px;gap:10px}form label[data-react-aria-pressable]>div{flex-shrink:0}input[type="email"]{min-height:44px;font-size:16px}button[type="submit"]{min-height:44px;width:100%;font-size:12px}form>div:last-child>div{width:100%}[slot="errorMessage"]:empty{display:none}}`;shadow.appendChild(style);}
function initBwSpoks(){document.querySelectorAll('[data-bw-spoks]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const dialog=root.querySelector('dialog');const launch=root.querySelector('.bw-spoks-launch');const intro=root.querySelector('.bw-spoks-intro');const form=root.querySelector('.bw-spoks-form');compactBwSpoks(root);launch.addEventListener('click',()=>{intro.hidden=false;form.hidden=true;dialog.showModal();});root.querySelector('.bw-spoks-claim').addEventListener('click',()=>{intro.hidden=true;form.hidden=false;compactBwSpoks(root);form.querySelector('h2').focus();});root.querySelectorAll('.bw-spoks-close,.bw-spoks-dismiss').forEach(button=>button.addEventListener('click',()=>dialog.close()));dialog.addEventListener('close',()=>launch.focus());});}initBwSpoks();document.addEventListener('shopify:section:load',initBwSpoks);

  } catch(e) { console.error(e); }
})();
})();
